<template>
  <div class="page_body">
    <HomeTop :topTitle="topTitle"></HomeTop>
    <div class="result-detail-container">
      <!-- 考试基本信息 -->
      <div class="exam-info-card">
        <div class="exam-header">
          <h2 class="exam-title">{{ examData.title }}</h2>
          <div class="exam-level">{{ examData.level }}</div>
        </div>
        <div class="exam-description">
          <h3>考试说明：</h3>
          <p>根据《{{ examData.reference }}》，对照专业篮球运动员技术、体能指标，为业余青少年篮球选手提供的技能评测体系，是官方认可的，具有行业权威性和实际指导意义的技术等及标准体系。以本测试为依据，可以较为充分的评估青少年在本年龄段的技能水平，运动表现和健康程度。希望通过篮球训练和考试，助力保持广大青少年的身心健康。</p>
        </div>
      </div>

      <!-- 考生基本信息 -->
      <div class="student-info-card">
        <div class="info-grid">
          <div class="info-item">
            <span class="label">姓名：</span>
            <span class="value">{{ studentInfo.name }}</span>
          </div>
          <div class="info-item">
            <span class="label">性别：</span>
            <span class="value">{{ studentInfo.gender }}</span>
          </div>
          <div class="info-item">
            <span class="label">出生日期：</span>
            <span class="value">{{ studentInfo.birthDate }}</span>
          </div>
          <div class="info-item">
            <span class="label">身高：</span>
            <span class="value">{{ studentInfo.height }}cm</span>
          </div>
          <!-- <div class="info-item">
            <span class="label">体重：</span>
            <span class="value">{{ studentInfo.weight }}kg</span>
          </div> -->
          <div class="info-item">
            <span class="label">测试时间：</span>
            <span class="value">{{ studentInfo.testTime }}</span>
          </div>
          <div class="info-item">
            <span class="label">测试地点：</span>
            <span class="value">{{ studentInfo.testLocation }}</span>
          </div>
          <div class="info-item">
            <span class="label">所在机构：</span>
            <span class="value">{{ studentInfo.organization }}</span>
          </div>
          <div class="info-item">
            <span class="label">所在区：</span>
            <span class="value">{{ studentInfo.district }}</span>
          </div>
          <div class="info-item">
            <span class="label">教练员：</span>
            <span class="value">{{ studentInfo.coach }}</span>
          </div>
        </div>
        <div class="student-photo">
          <img :src="studentInfo.photo" alt="考生照片">
        </div>
      </div>

      <!-- 考试内容 -->
      <div class="exam-content">
        <!-- 基本技术板块 -->
        <div class="tech-section section-card">
          <div class="section-header">
            <h3>1. 基本技术板块</h3>
            <span class="total-score">{{ isLevel4 ? '满分60分' : '满分100分' }}</span>
          </div>
          <div class="section-desc">
            <h4>考试说明：</h4>
            <p>从"运、传、投、防"四个维度，分别检测青少年的篮球基本功水平。考生根据考官要求，完成各项技术动作，要求尽可能规范到位。</p>
          </div>
          <div class="test-items">
            <div v-for="(item, index) in techItems" :key="index" class="test-item">
              <div class="item-header">
                <span class="item-name">{{ index + 1 }}. {{ item.name }}</span>
                <span class="item-score">{{ item.score }}/{{ item.total }}</span>
              </div>
              <el-button type="text" @click="showDeductions(item)">查看扣分详情</el-button>
            </div>
            <div class="total-result">
              <span>考试结果：{{ techScore }}/{{ isLevel4 ? '60' : '100' }}</span>
              <span class="grade">基本技术评定：{{ techGrade }}</span>
            </div>
          </div>
        </div>

        <!-- 运动能力板块 -->
        <div class="ability-section section-card" v-if="isLevel4">
          <div class="section-header">
            <h3>2. 运动能力板块</h3>
            <span class="total-score">满分45分</span>
          </div>
          <div class="section-desc">
            <h4>考试说明：</h4>
            <p>采集七至十项专业指标，从"力量、敏捷、耐力"三个维度，评估青少年当前的运动能力。考生根据考官要求，佩戴芯片并完成模拟训练课程。</p>
          </div>
          <div class="ability-items">
            <div class="ability-item">
              <span class="item-name">力量</span>
              <span class="item-score">{{ abilityScores.strength }}/15</span>
              <!-- <el-button type="text" @click="showAbilityDeductions('strength')">查看扣分详情</el-button> -->
            </div>
            <div class="ability-item">
              <span class="item-name">敏捷</span>
              <span class="item-score">{{ abilityScores.agility }}/15</span>
              <!-- <el-button type="text" @click="showAbilityDeductions('agility')">查看扣分详情</el-button> -->
            </div>
            <div class="ability-item">
              <span class="item-name">耐力</span>
              <span class="item-score">{{ abilityScores.endurance }}/15</span>
              <!-- <el-button type="text" @click="showAbilityDeductions('endurance')">查看扣分详情</el-button> -->
            </div>
          </div>
          <!-- <div class="ability-chart" ref="abilityChart"></div> -->
          <div class="simulation-result">
            <h4>查看全面数据分析</h4>
            <el-button type="primary" @click="watchVideo">查看分析图表</el-button>
          </div>
        </div>

        <!-- 模拟战板块 -->
        <div class="simulation-section section-card" v-if="isLevel4">
          <div class="section-header">
            <h3>3. 模拟战板块</h3>
            <span class="note">不计分</span>
          </div>
          <div class="section-desc">
            <h4>考试说明：</h4>
            <p>实战成绩在初级阶段仅提供参考价值。青少年身体发育情况不一，无须过于看重比赛胜负，保持身心健康，提高基本技术，未来空间无限。</p>
          </div>
          <!-- <div class="simulation-result">
            <h4>模拟比赛结果</h4>
            <el-button type="primary" @click="watchVideo">查看比赛录像</el-button>
          </div> -->
        </div>

        <!-- 测试报告 -->
        <div class="report-section section-card">
          <h3>测试报告</h3>
          <div class="total-scores">
            <div class="score-item">
              <span class="label">总得分：</span>
              <span class="value">{{ isLevel4 ? totalScore + '/105' : techScore + '/100' }}</span>
            </div>
            <div class="score-item">
              <span class="label">基本技术得分：</span>
              <span class="value">{{ techScore }}/{{ isLevel4 ? '60' : '100' }}</span>
              <span class="grade">评价：{{ techGrade }}</span>
            </div>
            <div class="score-item" v-if="isLevel4">
              <span class="label">运动能力得分：</span>
              <span class="value">{{ abilityTotal }}/45</span>
              <span class="grade">评价：{{ abilityGrade }}</span>
            </div>
            <div class="score-item" v-if="isLevel4">
              <span class="label">模拟战：</span>
              <span class="value">不记分</span>
              <span class="grade">评价：{{ simulationGrade }}</span>
            </div>
          </div>

          <!-- 七边形能力图 -->
          <div class="radar-chart-container">
            <div class="radar-chart-wrapper">
              <div ref="radarChart" class="radar-chart"></div>
            </div>
          </div>

          <!-- 证书图片 -->
          <div class="certificate-section">
            <img :src="certificateUrl" alt="证书" class="certificate-img">
          </div>

          <!-- 综合评价 -->
          <div class="evaluation-section">
            <h4>综合评价</h4>
            <p>{{ evaluation }}</p>
          </div>
        </div>
      </div>
    </div>
    <HomeFooter :activeKey="activeKey"></HomeFooter>

    <!-- 扣分详情弹窗 -->
    <el-dialog
      title="扣分详情"
      :visible.sync="deductionDialogVisible"
      width="80%">
      <div class="deduction-list">
        <div v-for="(deduct, index) in currentDeductions" :key="index" class="deduction-item">
          <span class="reason">{{ deduct.reason }}</span>
          <span class="points">-{{ deduct.points }}分</span>
        </div>
        <div v-if="!currentDeductions.length" class="no-deductions">
          无扣分项
        </div>
      </div>
    </el-dialog>

    <!-- 运动数据分析弹窗 -->
    <el-dialog
      title="运动数据分析报告"
      :visible.sync="analysisDialogVisible"
      width="90%"
      class="analysis-dialog">
      <div class="analysis-report">
        <!-- 基本信息 -->
        <div class="report-header">
          <div class="basic-info">
            <div class="student-info">
              <span class="name">{{ studentInfo.name }}</span>
              <span class="level">{{ examData.level }}</span>
            </div>
            <div class="test-time">
              测试日期：{{ studentInfo.testTime }}
            </div>
          </div>
        </div>

        <!-- 时间距离数据 -->
        <div class="time-distance-data">
          <div class="data-box">
            <div class="label">时长</div>
            <div class="value">{{ testDuration }}</div>
          </div>
          <div class="data-box">
            <div class="label">距离(米)</div>
            <div class="value red">{{ testDistance }}</div>
          </div>
          <div class="data-box">
            <div class="label">距离/分钟(米)</div>
            <div class="value">{{ distancePerMinute }}</div>
          </div>
        </div>

        <!-- 运动指标数据 -->
        <div class="metrics-grid">
          <!-- 速度指标 -->
          <div class="metric-item">
            <div class="metric-header">
              <div class="metric-icon">
                <i class="el-icon-lightning"></i>
              </div>
              <div class="metric-title">速度（最大值）km/h</div>
            </div>
            <div class="metric-chart">
              <div class="chart-line" data-max="30">
                <div class="value-point" :style="{ left: getValuePosition(speed, 30) + '%' }">
                  {{ speed }}
                </div>
              </div>
              <div class="reference-lines">
                <div class="line">
                  <span class="line-label">同龄学员中位值</span>
                  <span class="line-value">17.56</span>
                </div>
                <div class="line">
                  <span class="line-label">职业学员中位值</span>
                  <span class="line-value">23.65</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 加速负荷 -->
          <div class="metric-item">
            <div class="metric-header">
              <div class="metric-icon">
                <i class="el-icon-timer"></i>
              </div>
              <div class="metric-title">加速负荷（最大值）</div>
            </div>
            <div class="metric-chart">
              <div class="chart-line" data-max="30">
                <div class="value-point" :style="{ left: getValuePosition(accelerationLoad, 30) + '%' }">
                  {{ accelerationLoad }}
                </div>
              </div>
              <div class="reference-lines">
                <div class="line">
                  <span class="line-label">同龄学员中位值</span>
                  <span class="line-value">17.56</span>
                </div>
                <div class="line">
                  <span class="line-label">职业学员中位值</span>
                  <span class="line-value">23.65</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 方向改变 -->
          <div class="metric-item">
            <div class="metric-header">
              <div class="metric-icon">
                <i class="el-icon-refresh"></i>
              </div>
              <div class="metric-title">方向的改变（次）</div>
            </div>
            <div class="metric-chart">
              <div class="chart-line" data-max="30">
                <div class="value-point" :style="{ left: getValuePosition(directionChanges, 30) + '%' }">
                  {{ directionChanges }}
                </div>
              </div>
              <div class="reference-lines">
                <div class="line">
                  <span class="line-label">同龄学员中位值</span>
                  <span class="line-value">17.56</span>
                </div>
                <div class="line">
                  <span class="line-label">职业学员中位值</span>
                  <span class="line-value">23.65</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 力学强度 -->
          <div class="metric-item">
            <div class="metric-header">
              <div class="metric-icon">
                <i class="el-icon-heavy-rain"></i>
              </div>
              <div class="metric-title">力学强度</div>
            </div>
            <div class="metric-chart">
              <div class="chart-line" data-max="30">
                <div class="value-point" :style="{ left: getValuePosition(mechanicalIntensity, 30) + '%' }">
                  {{ mechanicalIntensity }}
                </div>
              </div>
              <div class="reference-lines">
                <div class="line">
                  <span class="line-label">同龄学员中位值</span>
                  <span class="line-value">17.56</span>
                </div>
                <div class="line">
                  <span class="line-label">职业学员中位值</span>
                  <span class="line-value">23.65</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 跳跃次数 -->
          <div class="metric-item">
            <div class="metric-header">
              <div class="metric-icon">
                <i class="el-icon-top"></i>
              </div>
              <div class="metric-title">跳跃（次）</div>
            </div>
            <div class="metric-chart">
              <div class="chart-line" data-max="30">
                <div class="value-point" :style="{ left: getValuePosition(jumps, 30) + '%' }">
                  {{ jumps }}
                </div>
              </div>
              <div class="reference-lines">
                <div class="line">
                  <span class="line-label">同龄学员中位值</span>
                  <span class="line-value">12</span>
                </div>
                <div class="line">
                  <span class="line-label">职业学员中位值</span>
                  <span class="line-value">24</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 累积加速负荷 -->
          <div class="metric-item wide">
            <div class="metric-header">
              <div class="metric-icon">
                <i class="el-icon-data-line"></i>
              </div>
              <div class="metric-title">累积加速负荷</div>
            </div>
            <div class="metric-chart">
              <div class="chart-line" data-max="300">
                <div class="value-point" :style="{ left: getValuePosition(accumulatedLoad, 300) + '%' }">
                  {{ accumulatedLoad }}
                </div>
              </div>
              <div class="reference-lines">
                <div class="line">
                  <span class="line-label">同龄学员中位值</span>
                  <span class="line-value">132.32</span>
                </div>
                <div class="line">
                  <span class="line-label">职业学员中位值</span>
                  <span class="line-value">245.31</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 运动量 -->
          <div class="metric-item">
            <div class="metric-header">
              <div class="metric-icon">
                <i class="el-icon-odometer"></i>
              </div>
              <div class="metric-title">运动量</div>
            </div>
            <div class="metric-chart">
              <div class="chart-line" data-max="30">
                <div class="value-point" :style="{ left: getValuePosition(exerciseVolume, 30) + '%' }">
                  {{ exerciseVolume }}
                </div>
              </div>
              <div class="reference-lines">
                <div class="line">
                  <span class="line-label">同龄学员中位值</span>
                  <span class="line-value">12</span>
                </div>
                <div class="line">
                  <span class="line-label">职业学员中位值</span>
                  <span class="line-value">24</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 单项数据解释 -->
        <div class="data-interpretation">
          <h3>单项数据解释</h3>
          <div class="interpretation-content">
            <p><strong>速度：</strong>一次训练课中一个阶段内有效跑速度最大值即为最大速度，该值越大表明爆发力越好。</p>
            <p><strong>方向的改变：</strong>记录运动员在场上变向的次数，变化次数多说明该名运动员在场上移动灵活。</p>
            <p><strong>跳跃：</strong>与训练课比赛时特点相关的各种跳跃次数，数字越大说明对下肢的负荷越大。</p>
            <p><strong>加速负荷：</strong>每个加速过程中的最大负荷值，该值越大说明爆发力越好。</p>
            <p><strong>力学强度：</strong>使用加速度计算得到的瞬时值，静止时为零，运动时越大说明运动强度越大。</p>
            <p><strong>累积加速负荷：</strong>在一次训练课中，由加速产生的所有瞬时值累加得到，反映了整体运动负荷。</p>
          </div>
        </div>

        <!-- VEAI技术介绍 -->
        <div class="veai-introduction">
          <h3>VEAI技术特点</h3>
          <div class="tech-features">
            <div class="feature">
              <i class="el-icon-cpu"></i>
              <h4>完全自动化</h4>
              <p>采用先进的AI算法，实现数据的自动采集、处理和分析，无需人工干预。</p>
            </div>
            <div class="feature">
              <i class="el-icon-aim"></i>
              <h4>高精度定位</h4>
              <p>精确到厘米级的位置和运动数据采集，为运动表现分析提供可靠数据支持。</p>
            </div>
            <div class="feature">
              <i class="el-icon-timer"></i>
              <h4>零延迟响应</h4>
              <p>近乎零延迟的实时数据传输和处理，确保教练和运动员获得即时反馈。</p>
            </div>
            <div class="feature">
              <i class="el-icon-connection"></i>
              <h4>系统集成</h4>
              <p>与第三方系统无缝集成，支持数据导出和共享，扩展应用场景。</p>
            </div>
            <div class="feature">
              <i class="el-icon-mobile"></i>
              <h4>便携设计</h4>
              <p>采用小型轻便的芯片传感器，佩戴舒适，不影响运动表现。</p>
            </div>
            <div class="feature">
              <i class="el-icon-data-analysis"></i>
              <h4>数据洞察</h4>
              <p>为运动员、教练和观众提供深度的数据分析和即时洞察。</p>
            </div>
          </div>
        </div>

        <!-- VEAI计算公式 -->
        <div class="veai-formula">
          <h3>VEAI计算公式</h3>
          <div class="formula-content">
            <div class="formula-items">
              <div class="formula-item">
                <span class="formula-text">速度 + 方向改变 = 敏捷</span>
              </div>
              <div class="formula-item">
                <span class="formula-text">跳跃次数 × 累积加速负荷 + 运动量 = 耐力</span>
              </div>
              <div class="formula-item">
                <span class="formula-text">加速负荷最大值 × 力学强度 = 力量</span>
              </div>
            </div>
            <div class="scores">
              <div class="score-item">
                <div class="label">敏捷</div>
                <div class="value">{{ abilityScores.agility }}/15</div>
              </div>
              <div class="score-item">
                <div class="label">耐力</div>
                <div class="value">{{ abilityScores.endurance }}/15</div>
              </div>
              <div class="score-item">
                <div class="label">力量</div>
                <div class="value">{{ abilityScores.strength }}/15</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<style src="../../assets/css/user/resultDetail.css" scoped></style>

<script>
import HomeFooter from "@/components/homeFooter.vue";
import HomeTop from "@/components/homeTop.vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue';
import * as echarts from 'echarts';
import { getResultDetail } from '@/request/api';
Vue.use(ElementUI);

export default {
  name: "ResultDetail",
  components: {
    HomeFooter,
    HomeTop
  },
  data() {
    return {
      activeKey: 2,
      topTitle: "成绩详情",
      deductionDialogVisible: false,
      currentDeductions: [],
      resultId: null,
      examData: {
        title: "",
        level: "",
        reference: "",
      },
      studentInfo: {
        name: "",
        gender: "",
        birthDate: "",
        height: 0,
        weight: 0,
        testTime: "",
        testLocation: "",
        photo: require("@/assets/image/base_user_img01.png"),
        organization: "",
        district: "",
        coach: ""
      },
      techItems: [],
      abilityScores: {
        strength: 0,
        agility: 0,
        endurance: 0,
        deductions: {
          strength: [],
          agility: [],
          endurance: []
        }
      },
      radarData: {
        endurance: 0,
        strength: 0,
        agility: 0,
        passing: 0,
        defense: 0,
        dribbling: 0,
        shooting: 0,
      },
      certificateUrl: "",
      evaluation: "",
      analysisDialogVisible: false, // 新增：运动数据分析弹窗的可见性
      testDuration: 0, // 新增：测试时长
      testDistance: 0, // 新增：测试距离
      distancePerMinute: 0, // 新增：距离/分钟
      speed: 0, // 新增：速度
      accelerationLoad: 0, // 新增：加速负荷
      directionChanges: 0, // 新增：方向改变
      mechanicalIntensity: 0, // 新增：力学强度
      jumps: 0, // 新增：跳跃次数
      accumulatedLoad: 0, // 新增：累积加速负荷
      exerciseVolume: 0, // 新增：运动量
    };
  },
  computed: {
    // 判断是否为4级考试
    isLevel4() {
      return this.examData.level && this.examData.level.includes('4级');
    },
    // 判断是否为3级考试
    isLevel3() {
      return this.examData.level && this.examData.level.includes('3级');
    },
    techScore() {
      // 将每个技术项目的分数转换为数字并相加
      return this.techItems.reduce((sum, item) => {
        const score = parseFloat(item.score) || 0;
        return sum + score;
      }, 0).toFixed(2);
    },
    abilityTotal() {
      return this.abilityScores.strength + this.abilityScores.agility + this.abilityScores.endurance;
    },
    totalScore() {
      return (parseFloat(this.techScore) + this.abilityTotal).toFixed(2);
    },
    techGrade() {
      const score = parseFloat(this.techScore);
      
      if (this.isLevel4) {
        // 4级：根据得分百分比进行评比
        const maxScore = 60;
        const percentage = (score / maxScore) * 100;
        if (percentage >= 90) return "优秀";
        if (percentage >= 80) return "良好";
        if (percentage >= 60) return "合格";
        return "不合格";
      } else {
        // 1-3级：根据实际得分进行评比
        // 不合格（0~59分）、合格（60~75分）、良好（76~85分）、优秀（86~100分）
        if (score >= 86) return "优秀";
        if (score >= 76) return "良好";
        if (score >= 60) return "合格";
        return "不合格";
      }
    },
    abilityGrade() {
      const score = (this.abilityTotal / 45) * 100;
      if (score >= 90) return "优秀";
      if (score >= 80) return "良好";
      if (score >= 60) return "合格";
      return "不合格";
    },
    simulationGrade() {
      return "良好"; // 模拟值
    }
  },
  methods: {
    showDeductions(item) {
      this.currentDeductions = item.deductions;
      this.deductionDialogVisible = true;
    },
    showAbilityDeductions(type) {
      this.currentDeductions = this.abilityScores.deductions[type];
      this.deductionDialogVisible = true;
    },
    // 新增：显示运动数据分析弹窗
    watchVideo() {
      this.$router.push({
        path: '/analysisReport',
        query: {
          id: this.resultId
        }
      });
    },
    // 新增：计算值在图表中的位置
    getValuePosition(value, max) {
      return (value / max) * 100;
    },
    // 新增：格式化时间
    formatDuration(startTime, endTime) {
      if (!startTime || !endTime) return '00:00:00';
      const start = new Date(`2000-01-01 ${startTime}`);
      const end = new Date(`2000-01-01 ${endTime}`);
      const diff = end - start;
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
    initAbilityChart() {
      const chart = echarts.init(this.$refs.abilityChart);
      const option = {
        title: {
          text: '运动能力分析',
          left: 'center',
          textStyle: {
            fontSize: 16,
            color: '#333'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '1%',
          right: '18%',
          bottom: '10%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['力量', '敏捷', '耐力'],
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          max: 15,
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [
          {
            name: '得分',
            type: 'bar',
            barWidth: '40%',
            data: [
              {
                value: this.abilityScores.strength,
                itemStyle: {
                  color: '#409EFF'
                }
              },
              {
                value: this.abilityScores.agility,
                itemStyle: {
                  color: '#67C23A'
                }
              },
              {
                value: this.abilityScores.endurance,
                itemStyle: {
                  color: '#E6A23C'
                }
              }
            ],
            label: {
              show: true,
              position: 'top',
              formatter: '{c}/15'
            }
          }
        ]
      };
      chart.setOption(option);
    },
    initRadarChart() {
      const chart = echarts.init(this.$refs.radarChart);
      const option = {
        title: {
          text: '综合能力评估',
          left: 'center',
          top: 10,
          textStyle: {
            fontSize: 16,
            color: '#333'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: ['能力评估']
        },
        radar: {
          shape: 'polygon',
          center: ['50%', '50%'],
          radius: '55%',
          nameGap: 15,
          splitNumber: 5,
          axisName: {
            color: '#666',
            fontSize: 12,
            padding: [0, 15]
          },
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          },
          splitLine: {
            lineStyle: {
              color: ['#ddd']
            }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.1)']
            }
          },
          indicator: this.isLevel4 ? [
            { name: '耐力', max: 15 },
            { name: '力量', max: 15 },
            { name: '敏捷', max: 15 },
            { name: '传球', max: 15 },
            { name: '防守', max: 15 },
            { name: '运球', max: 15 },
            { name: '投篮', max: 15 }
          ] : this.isLevel3 ? [
            { name: '投篮', max: 40 },
            { name: '运球', max: 30 },
            { name: '防守', max: 10 },
            { name: '传球', max: 20 }
          ] : [
            { name: '投篮', max: 25 },
            { name: '运球', max: 25 },
            { name: '防守', max: 25 },
            { name: '传球', max: 25 }
          ]
        },
        series: [{
          name: '能力评估',
          type: 'radar',
          symbolSize: 6,
          data: [{
            value: this.isLevel4 ? [
              this.radarData.endurance,
              this.radarData.strength,
              this.radarData.agility,
              this.radarData.passing,
              this.radarData.defense,
              this.radarData.dribbling,
              this.radarData.shooting
            ] : [
              this.radarData.shooting,
              this.radarData.dribbling,
              this.radarData.defense,
              this.radarData.passing
            ],
            name: '能力评估',
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#409EFF'
            },
            lineStyle: {
              color: '#409EFF',
              width: 2
            },
            areaStyle: {
              color: 'rgba(64, 158, 255, 0.2)'
            }
          }]
        }]
      };
      chart.setOption(option);
      
      // 添加窗口大小改变时的自适应
      window.addEventListener('resize', () => {
        chart.resize();
      });

      // 确保图表完全渲染后再次调整大小
      setTimeout(() => {
        chart.resize();
      }, 0);
    },
    async fetchResultDetail() {
      try {
        const response = await getResultDetail(this.resultId);
        if (response.code === 200) {
          const data = response.data;
          console.log('成绩详情数据:', data);
          
          // 更新考试信息
          this.examData = {
            title: data.exam.title || '',
            level: data.exam.level || '',
            reference: data.exam.reference || ''
          };
          
          // 更新考生信息
          this.studentInfo = {
            ...this.studentInfo,
            ...data.student
          };
          
          // 更新技术项目成绩
          this.techItems = data.technical_scores.map(item => ({
            name: item.name || '',
            score: item.score || 0,
            total: (this.isLevel4 || this.isLevel3) ? (item.total_score || 0) : 25, // 3级和4级使用接口数据，1-2级固定25分
            deductions: Array.isArray(item.deductions) ? item.deductions : []
          }));
          
          // 更新运动能力成绩
          const abilityData = data.ability_scores || {};
          this.abilityScores = {
            strength: parseFloat(abilityData.strength || 0),
            agility: parseFloat(abilityData.agility || 0),
            endurance: parseFloat(abilityData.endurance || 0),
            deductions: {
              strength: Array.isArray(abilityData.deductions?.strength) ? abilityData.deductions.strength : [],
              agility: Array.isArray(abilityData.deductions?.agility) ? abilityData.deductions.agility : [],
              endurance: Array.isArray(abilityData.deductions?.endurance) ? abilityData.deductions.endurance : []
            }
          };

          // 新增：更新运动数据
          this.testDuration = this.formatDuration(data.student.testTime, data.student.testEndTime);
          this.testDistance = 468; // 示例数据，需要从后端获取
          this.distancePerMinute = 27; // 示例数据，需要从后端获取
          this.speed = 17.56; // 示例数据，需要从后端获取
          this.accelerationLoad = 17.56; // 示例数据，需要从后端获取
          this.directionChanges = 17; // 示例数据，需要从后端获取
          this.mechanicalIntensity = 17.56; // 示例数据，需要从后端获取
          this.jumps = 17; // 示例数据，需要从后端获取
          this.accumulatedLoad = 170.56; // 示例数据，需要从后端获取
          this.exerciseVolume = 17; // 示例数据，需要从后端获取
          
          // 更新雷达图数据
          this.radarData = data.radar_data || {
            endurance: 0,
            strength: 0,
            agility: 0,
            passing: 0,
            defense: 0,
            dribbling: 0,
            shooting: 0
          };
          
          // 更新评价 - 直接使用 score_detail_level4 表中的 exam_comments 字段
          this.evaluation = data.exam_comments || data.evaluation || '';
          
          // 更新证书链接 - 从后端获取，前面添加 /api 前缀
          this.certificateUrl = data.certificate ? '/api' + data.certificate : require("@/assets/image/certificate01.png");
          
          // 初始化图表
          this.$nextTick(() => {
            this.initRadarChart();
            this.initAbilityChart();
          });
        } else {
          console.error('获取成绩详情失败:', response.message);
          this.$message.error(response.message || '获取成绩详情失败');
        }
      } catch (error) {
        console.error('获取成绩详情失败:', error);
        this.$message.error(error.message || '获取成绩详情失败，请稍后重试');
      }
    }
  },
  created() {
    // 从查询参数获取成绩ID
    this.resultId = this.$route.query.id;
    console.log('成绩ID:', this.resultId);
    if (!this.resultId) {
      this.$message.error('未找到成绩信息');
      // this.$router.push('/results/list');
      return;
    }
    // 获取成绩详情
    this.fetchResultDetail();
  }
};
</script>
